import { Text, View } from '@react-pdf/renderer';
import { dateformat } from '../../../helpers';
import { cellPdf, stylesPdf } from '../../pdfs';
import { rolesArray } from '../../usuario/usuarios/components/SelectFieldRoles';
import { columnsReportesAccesos } from './ReportesAccesos';

const columnWidths = {
  dni: 11,
  fullname: 30,
  rol: 10,
  genero: 8,
  entrada: 18,
  salida: 18,
  seguridadEntrada: 20,
  seguridadSalida: 20,
};

const row = (columns, el, i) => {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: i,
        width: '5%',
      })}
      {columns.map((column, index) => {
        let data;
        const isUltimo = columns.length - 1 === index;

        if (column.id === 'dni') {
          data = el.usuario.perfil.dni;
        }

        if (column.id === 'fullname') {
          data = `${el.usuario.perfil.pnombre} ${
            el.usuario.perfil.snombre ?? ''
          } ${el.usuario.perfil.papellido} ${
            el.usuario.perfil.sapellido ?? ''
          }`;
        }

        if (column.id === 'genero') {
          data = el.usuario.perfil.genero;
        }

        if (column.id === 'rol') {
          data = rolesArray[el.usuario.rol];
        }

        if (column.id === 'entrada') {
          data = el.entrada
            ? dateformat(el.entrada, { format: 'DD-MM-YYYY hh:mm A' })
            : null;
        }

        if (column.id === 'salida') {
          data = el.salida
            ? dateformat(el.salida, { format: 'DD-MM-YYYY hh:mm A' })
            : null;
        }

        if (column.id === 'seguridadEntrada') {
          data = `${el.segEntrada.perfil.pnombre} ${
            el.segEntrada.perfil.snombre ?? ''
          } ${el.segEntrada.perfil.papellido} ${
            el.segEntrada.perfil.sapellido ?? ''
          }`;
        }

        if (column.id === 'seguridadSalida') {
          data = `${el.segEntrada.perfil.pnombre} ${
            el.segEntrada.perfil.snombre ?? ''
          } ${el.segEntrada.perfil.papellido} ${
            el.segEntrada.perfil.sapellido ?? ''
          }`;
        }

        return cellPdf({
          value: data,
          width: `${columnWidths[column.id]}%`,
          stylesCell: {
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
};

function header(columns) {
  return (
    <View style={stylesPdf.row}>
      {cellPdf({
        value: 'Nro',
        width: '5%',
        bold: true,
        color: '#D6D6D6',
        stylesCell: {
          borderTopWidth: 1,
        },
      })}
      {columns.map((column, index) => {
        const isUltimo = columns.length - 1 === index;
        return cellPdf({
          value: column.name,
          width: `${columnWidths[column.id]}%`,
          bold: true,
          color: '#D6D6D6',
          stylesCell: {
            borderTopWidth: 1,
            borderRightWidth: isUltimo ? 1 : 0,
          },
        });
      })}
    </View>
  );
}

const TablaReportesAccesos = ({ data, columnSelect }) => {
  const columns = [];
  columnSelect.map((el) =>
    columns.push(columnsReportesAccesos.find((e) => e.id === el)),
  );

  return (
    <View style={stylesPdf.section}>
      <View style={{ paddingBottom: 10 }}>
        <Text style={stylesPdf.title}>LISTA DE ACCESOS</Text>
      </View>
      {header(columns)}
      {data.map((el, i) => row(columns, el, i + 1))}
    </View>
  );
};

export default TablaReportesAccesos;
